var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMouse2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.303,
    height: 74.177,
    viewBox: "0 0 58.303 74.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21009",
    "data-name": "Group 21009",
    transform: "translate(19080.912 14269.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7666",
    "data-name": "Path 7666",
    d: "M104.39,10.924H91.943a16.067,16.067,0,0,0-16,16V58.176a16,16,0,0,0,16,16H104.39a16,16,0,0,0,16-16V26.924a16,16,0,0,0-16-16M93.038,36.567H79.362V28.019a13.6,13.6,0,0,1,.909-4.87c.095-.251.195-.5.3-.742a13.669,13.669,0,0,1,12.462-8.064Z",
    transform: "translate(-19143 -14269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7667",
    "data-name": "Path 7667",
    d: "M76.612,8.245a1.777,1.777,0,0,0,2.666.832l.043-.029a1.841,1.841,0,0,0,.718-2.184L77.918,1.2A1.846,1.846,0,1,0,74.46,2.494Z",
    transform: "translate(-19143 -14269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7668",
    "data-name": "Path 7668",
    d: "M71.766,21.478l.009-.079a1.835,1.835,0,0,0-1.852-2.02l-6.006.056A1.847,1.847,0,0,0,62.088,21.3v0a1.846,1.846,0,0,0,1.862,1.83l6.075-.05a1.773,1.773,0,0,0,1.741-1.6",
    transform: "translate(-19143 -14269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7669",
    "data-name": "Path 7669",
    d: "M65.54,8.695l0,0a1.848,1.848,0,0,0,.471,2.569l5.531,3.817a1.777,1.777,0,0,0,2.533-.566l.01-.017a1.861,1.861,0,0,0-.508-2.509L68.108,8.224a1.846,1.846,0,0,0-2.568.471",
    transform: "translate(-19143 -14269)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMouse2);
export default __webpack_public_path__ + "static/media/icon_mouse2.5f73ed49206c9b686ced3ac3b099e237.svg";
export { ForwardRef as ReactComponent };